import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

// Fixed "New Provider" details (moving to Orange Business - not editable)
const NEW_PROVIDER_NAME = 'Orange Business';
const NEW_PROVIDER_ADDRESS = 'BT IPEX / Orange Business, 4th Floor, The Porter Building, 1 Brunel Way, Slough, SL1 1FQ';
const NEW_PROVIDER_EMAIL = 'gnp@easymail.orange.com';

function UkIreland() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));
            if (form?.country?.country === 'United Kingdom & Ireland') {
                fillForm(form);
            }
        };
        fetchData();
    }, [dispatch, navigate, userEmail]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

    const [curName, setCurName] = useState();
    const [curAddress, setCurAddress] = useState();
    const [curEmail, setCurEmail] = useState();

    const [newName, setNewName] = useState(NEW_PROVIDER_NAME);
    const [newAddress, setNewAddress] = useState(NEW_PROVIDER_ADDRESS);
    const [newEmail, setNewEmail] = useState(NEW_PROVIDER_EMAIL);

    const [mbn, setMbn] = useState();
    const [checkBox, setCheckBox] = useState(false);

    const [bName, setBName] = useState();
    const [sName, setSName] = useState();
    const [town, setTown] = useState();
    const [country, setCountry] = useState();
    const [postCode, setPostCode] = useState();

    const [cBName, setCBName] = useState();
    const [cSName, setCSName] = useState();
    const [cTown, setCTown] = useState();
    const [cCountry, setCCountry] = useState();
    const [cPostCode, setCPostCode] = useState();
    const [cRegNum, setCRegNum] = useState();
    const [accNum, setAccNum] = useState();

    const [signature, setSignature] = useState();
    const [name, setName] = useState();
    const [date, setDate] = useState();
    const [title, setTitle] = useState();
    const [email, setEmail] = useState();
    //-----------------------------------------------FillForm-------------------------------------------------//



    const fillForm = (form) => {
        const JSONData = form;

        // Update React state for controlled components
        setCurName(JSONData?.country?.providerDetails?.current?.name ?? '');
        setCurAddress(JSONData?.country?.providerDetails?.current?.address ?? '');
        setCurEmail(JSONData?.country?.providerDetails?.current?.email ?? '');
        setNewName(NEW_PROVIDER_NAME);
        setNewAddress(NEW_PROVIDER_ADDRESS);
        setNewEmail(NEW_PROVIDER_EMAIL);
        setMbn(JSONData?.country?.portedNumbers?.mbn ?? '');
        setCheckBox(JSONData?.country?.portedNumbers?.checkBox ?? false);
        setTableData(JSONData?.country?.portedNumbers?.range ?? []);

        setBName(JSONData?.country?.address?.building ?? '');
        setSName(JSONData?.country?.address?.street ?? '');
        setTown(JSONData?.country?.address?.city ?? '');
        setCountry(JSONData?.country?.address?.country ?? '');
        setPostCode(JSONData?.country?.address?.code ?? '');

        setCBName(JSONData?.country?.companyDetails?.building ?? '');
        setCSName(JSONData?.country?.companyDetails?.street ?? '');
        setCTown(JSONData?.country?.companyDetails?.city ?? '');
        setCCountry(JSONData?.country?.companyDetails?.country ?? '');
        setCPostCode(JSONData?.country?.companyDetails?.code ?? '');
        setCRegNum(JSONData?.country?.companyDetails?.registration ?? '');
        setAccNum(JSONData?.country?.companyDetails?.account ?? '');

        setSignature(JSONData?.country?.requestorDetails?.signature ?? '');
        setName(JSONData?.country?.requestorDetails?.name ?? '');
        setDate(JSONData?.country?.requestorDetails?.date ?? '');
        setTitle(JSONData?.country?.requestorDetails?.job ?? '');
        setEmail(JSONData?.country?.requestorDetails?.email ?? '');

        // Optional: Update DOM directly only if absolutely necessary
        const updateDOM = (selector, value) => {
            const element = document.querySelector(selector);
            if (element) {
                element.value = value;
            }
        };

        // Update non-controlled fields (fallback for special cases)
        updateDOM('#curName', JSONData?.country?.providerDetails?.current?.name ?? '');
        updateDOM('#curAddress', JSONData?.country?.providerDetails?.current?.address ?? '');
        updateDOM('#curEmail', JSONData?.country?.providerDetails?.current?.email ?? '');
        updateDOM('#newName', NEW_PROVIDER_NAME);
        updateDOM('#newAddress', NEW_PROVIDER_ADDRESS);
        updateDOM('#newEmail', NEW_PROVIDER_EMAIL);
        updateDOM('#mbn', JSONData?.country?.portedNumbers?.mbn ?? '');
        const checkBoxElement = document.querySelector('#checkBox');
        if (checkBoxElement) {
            checkBoxElement.checked = JSONData?.country?.portedNumbers?.checkBox ?? false;
        }
        updateDOM('#bName', JSONData?.country?.address?.building ?? '');
        updateDOM('#sName', JSONData?.country?.address?.street ?? '');
        updateDOM('#town', JSONData?.country?.address?.city ?? '');
        updateDOM('#country', JSONData?.country?.address?.country ?? '');
        updateDOM('#postCode', JSONData?.country?.address?.code ?? '');
        updateDOM('#cBName', JSONData?.country?.companyDetails?.building ?? '');
        updateDOM('#cSName', JSONData?.country?.companyDetails?.street ?? '');
        updateDOM('#cTown', JSONData?.country?.companyDetails?.city ?? '');
        updateDOM('#cCountry', JSONData?.country?.companyDetails?.country ?? '');
        updateDOM('#cPostCode', JSONData?.country?.companyDetails?.code ?? '');
        updateDOM('#cRegNum', JSONData?.country?.companyDetails?.registration ?? ''); 
        updateDOM('#accNum', JSONData?.country?.companyDetails?.account ?? '');
        updateDOM('#signature', JSONData?.country?.requestorDetails?.signature ?? '');
        updateDOM('#name', JSONData?.country?.requestorDetails?.name ?? '');
        updateDOM('#date', JSONData?.country?.requestorDetails?.date ?? '');
        updateDOM('#title', JSONData?.country?.requestorDetails?.job ?? '');
        updateDOM('#email', JSONData?.country?.requestorDetails?.email ?? '');
    };



    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field
    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };
    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableData, setTableData] = useState([{ id: Date.now(), FirstNumber: '', LastNumber: '', Count: '' }]);

    //adding a row
    const addRow = () => {
        setTableData([...tableData, { id: Date.now(), FirstNumber: '', LastNumber: '', Count: '' }]);
    };

    //removing a row
    const removeRow = (id) => {
        setTableData(tableData.filter(row => row.id !== id));
    };

    // change handler of table
    const handleChange_table = (id, key, value) => {
        const updatedData = tableData.map(row => {
            if (row.id === id) {
                const updatedRow = { ...row, [key]: value };

                // Calculate the count if FirstNumber or LastNumber is updated
                if (key === 'FirstNumber' || key === 'LastNumber') {
                    const start = parseInt(updatedRow.FirstNumber, 10);
                    const end = parseInt(updatedRow.LastNumber, 10);
                    if (!isNaN(start) && !isNaN(end) && end >= start) {
                        updatedRow.Count = end - start + 1;
                    } else {
                        updatedRow.Count = 0;
                    }
                }

                return updatedRow;
            }
            return row;
        });
        setTableData(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Display the file name
        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            const formattedRows = dataRows.map((row, index) => {
                const first = row[0]?.toString() || '';
                const last = row[1]?.toString() || '';
                const start = parseInt(first, 10);
                const end = parseInt(last, 10);

                let count = '';
                if (!isNaN(start) && !isNaN(end) && end >= start) {
                    count = (end - start + 1).toString();
                }

                return {
                    id: index + 1,
                    FirstNumber: first,
                    LastNumber: last,
                    Count: count,
                };
            });

            setTableData(formattedRows);

            // Validate each row
            const updatedValidation = {};
            formattedRows.forEach(row => {
                const startValid = /^\d{10,11}$/.test(row.FirstNumber);
                const endValid = /^\d{10,11}$/.test(row.LastNumber) && parseInt(row.LastNumber) >= parseInt(row.FirstNumber);
                updatedValidation[`start-${row.id}`] = startValid;
                updatedValidation[`end-${row.id}`] = endValid;
            });

            setValidationStates(updatedValidation);
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableData([{ id: Date.now(), FirstNumber: '', LastNumber: '', Count: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "United Kingdom & Ireland",
            "providerDetails": {
                "current": {
                    "name": curName,
                    "address": curAddress,
                    "email": curEmail
                },
                "new": {
                    "name": NEW_PROVIDER_NAME,
                    "address": NEW_PROVIDER_ADDRESS,
                    "email": NEW_PROVIDER_EMAIL
                }
            },
            "portedNumbers": {
                "mbn": mbn,
                "checkBox": checkBox,
                "range": tableData
            },
            "address": {
                "building": bName,
                "street": sName,
                "city": town,
                "country": country,
                "code": postCode
            },
            "companyDetails": {
                "building": cBName,
                "street": cSName,
                "city": cTown,
                "country": cCountry,
                "code": cPostCode,
                "registration": cRegNum,
                "account": accNum
            },
            "requestorDetails": {
                "signature": signature,
                "name": name,
                "date": date,
                "job": title,
                "email": email
            }
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);
    // console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {
        e.preventDefault();

        let validationErrors = {};

        // Validate other fields...
        if (!curName) {
            validationErrors.curName = 'Please enter the current provider\'s name';
        }
        if (!curAddress) {
            validationErrors.curAddress = 'Please enter the current provider\'s address';
        }
        if (!curEmail) {
            validationErrors.curEmail = 'Please enter the current provider\'s email';
        }
        // New provider details are fixed (Orange Business), so no validation needed
        // Validate MBN only if the checkbox is checked
        if (checkBox && !mbn) {
            validationErrors.mbn = 'Please enter the MBN';
        }
        // Continue with other validations...
        tableData.forEach((row, index) => {
            if (!row.FirstNumber) {
                validationErrors[`start-${row.id}`] = `Please fill in a number for row ${index + 1}`;
            }
            if (!row.LastNumber) {
                validationErrors[`end-${row.id}`] = `Please fill in a number for row ${index + 1}`;
            }
        });

        if (!bName) {
            validationErrors.bName = 'Please enter the building name';
        }
        if (!sName) {
            validationErrors.sName = 'Please enter the street name';
        }
        if (!town) {
            validationErrors.town = 'Please enter the town/city name';
        }
        if (!country) {
            validationErrors.country = 'Please enter the country';
        }
        if (!postCode) {
            validationErrors.postCode = 'Please enter the post code';
        }
        if (!cBName) {
            validationErrors.cBName = 'Please enter the company building name/number';
        }
        if (!cSName) {
            validationErrors.cSName = 'Please enter the company street name';
        }
        if (!cTown) {
            validationErrors.cTown = 'Please enter the company town/city';
        }
        if (!cCountry) {
            validationErrors.cCountry = 'Please enter the company country';
        }
        if (!cPostCode) {
            validationErrors.cPostCode = 'Please enter the company post code';
        }
        if (!cRegNum) {
            validationErrors.cRegNum = 'Please enter the company registration number';
        }
        if (!accNum) {
            validationErrors.accNum = 'Please enter the billing account number';
        }
        if (!signature) {
            validationErrors.signature = 'Please enter your signature';
        }
        if (!name) {
            validationErrors.name = 'Please enter your name';
        }
        if (!title) {
            validationErrors.title = 'Please enter your job title';
        }
        if (!date) {
            validationErrors.date = 'Please enter the date';
        }
        if (!email) {
            validationErrors.email = 'Please enter your email';
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            // Show the first error message
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];

            // Ensure that we only scroll if the element exists in the DOM
            const firstErrorElement = document.getElementById(firstErrorKey);
            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            }

            toast.error(firstError);
            return;
        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys}`);

            // Safely try to scroll to the first invalid field
            const elem = document.getElementById(falseKeys[0]);
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            }

            return;
        }

        // Show the modal instead of generating the LOA directly
        setIsModalVisible(true);
    }



    async function handleConfirm() {
        setIsModalVisible(false);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = curName + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
            // toast.error("An error occurred while processing your request.");
        }
    }

    //----------------------------------------------RESET AND SAVE-------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');

        window.location.reload();

    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);
        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }
        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <Container>

                    {
                        isModalVisible && (
                            <div className="modal">
                                <div className="modal-content">
                                    {/* <h3>New CLoA Template, Purpose, Ground Rules & Logistics</h3> */}
                                    <h3 style={{ textAlign: 'center' }}>New CLoA Template, Purpose, Ground Rules & Logistics</h3>
                                    <div className="modal-body">
                                        <ul>
                                            <li>
                                                A single CLoA template which caters for both <u>Geo & Non-Geo Numbers</u>, including ALL order types (i.e., <u>Single, Multi-line, Multi-number</u>).
                                            </li>
                                            <li>Provides <u>Customer authority</u> to initiate the port order.</li>
                                            <li>Provides <u>proof of ownership</u> (i.e., <u>legal right to port the numbers concerned</u>).</li>
                                            <li>
                                                Provides <u>authority</u> (to the current provider) to share details associated with the current service, with the new (gaining) provider, if requested to do so. On receipt of a request for information from the GP, the LP is obliged to engage, as necessary, with the GP to ensure an accurate port order can be raised.
                                            </li>
                                            <li>Provides <u>accurate details</u> regarding the specific numbers to be ported.</li>
                                            <li>Provides <u>accurate post code details</u> (Billing & Site-specific) to support any order validation checks which may need to be undertaken by the Losing N/W CP.</li>
                                            <li>Provides facility for <u>CLoA signatory</u> (i.e., the Customer) to also ‘cancel’ their order if they decide to do so subsequently.</li>
                                            <li>Provides <u>name, address, and contact details</u> for the two Retailers involved (i.e., Gaining & Losing).</li>
                                            <li>
                                                <u>Non-Geo Numbers</u> – A CLoA must always be obtained.
                                            </li>
                                            <li>
                                                <u>Geo M/L Numbers</u> - A CLoA must always be obtained.
                                            </li>
                                            <li>
                                                <u>Geo S/L Numbers</u> – For Business End Users (i.e., non-automated order), a CLoA must always be obtained.
                                            </li>
                                            <li>
                                                <u>Geo & Non-Geo numbers</u>: Once obtained, the GP must hold the CLoA on file for a min period of 1 year.
                                            </li>
                                            <li>
                                                Once obtained, the GP must forward the CLoA up their supply chain to the Gaining N/W CP.
                                            </li>
                                            <li>
                                                The GNCP must forward the CLoA to the Losing N/W CP if they so request it, within 24hrs.
                                            </li>
                                            <li>
                                                <u>CLoA – Inter-CP handling</u>: Once obtained, the GP must hold the CLoA on file for a minimum period of 1 year. Once obtained, the GP must forward the CLoA up their supply chain to the Gaining N/W CP. The GNCP must forward the CLoA to the Losing N/W CP if they so request it, within 24hrs.
                                            </li>
                                            <li>
                                                <u>CLoA Logistics</u>: A fully completed CLoA may be submitted in either of the following ways:
                                                <ul>
                                                    <li>
                                                        Scanned CLoA template with authorised signature sent as an email attachment from the Customer’s business email address (which must show their Business title, and the company’s full name & address).
                                                    </li>
                                                    <li>The attached CLoA may use <u>e-Signature</u>.</li>
                                                    <li>The email may use <u>e-Signature</u>.</li>
                                                    <li>The attached CLoA template does <u>not</u> need to be on letter-headed paper.</li>
                                                    <li>By exception, the CLoA signatory & the email originator do not have to be the same person.</li>
                                                    <li>Each CLoA will be <u>‘site-specific’</u> (i.e., additional CLoA required for each additional site).</li>
                                                </ul>
                                            </li>
                                            <li>
                                                <u>CLoA ‘format flexibility’</u> - Retailers may also transpose the new CLoA content into the Retailer’s standard order form (i.e., tailored to also meet the Retailer’s needs). This can then accommodate whatever e-signature method the provider chooses to use. The CLoA content must be fully transposed with all fields faithfully incorporated.
                                            </li>
                                            <li>
                                                Standalone CLoA template with authorised signature sent by Fax or posted letter:
                                                <ul>
                                                    <li>The CLoA must be signed by an authorised signatory and must be on letter-headed paper.</li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                    <label className="checkbox-label">
                                        <input
                                            type="checkbox"
                                            checked={isCheckboxChecked}
                                            onChange={(e) => setIsCheckboxChecked(e.target.checked)}
                                        />
                                        I agree to the terms and conditions
                                    </label>
                                    <div className="modal-actions">
                                        <button className="cancel-btn" onClick={() => setIsModalVisible(false)}>
                                            Cancel
                                        </button>
                                        <button
                                            className="confirm-btn"
                                            onClick={handleConfirm}
                                            disabled={!isCheckboxChecked}
                                        >
                                            Confirm
                                        </button>
                                    </div>
                                </div>
                            </div> 
                        )
                    }


                </Container>

                <Container>

                    <p><strong>Mandatory fields are marked by *</strong></p> <br></br>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Current Provider</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('curName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Name*</label> <br />
                            <input
                                onChange={(e) => setCurName(e.target.value)}
                                type="text"
                                id="curName"
                                placeholder=""
                                className={`inputbox ${validationStates.curName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('curName', /^[a-zA-Z0-9\s,.'-]+$/)}

                            />
                            {hoveredField === 'curName' && (
                                <div className="hover-description">
                                    Enter address
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('curAddress')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address*</label> <br />
                            <input
                                onChange={(e) => setCurAddress(e.target.value)}
                                type="text"
                                id="curAddress"
                                placeholder=""
                                className={`inputbox ${validationStates.curAddress === false ? 'error' : ''}`}
                                onBlur={() => validateInput('curAddress', /^[a-zA-Z0-9\s,.'-]+$/)}

                            />
                            {hoveredField === 'curAddress' && (
                                <div className="hover-description">
                                    Must be address in UK
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('curEmail')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Email*</label> <br />
                            <input
                                onChange={(e) => setCurEmail(e.target.value)}
                                type="text"
                                id="curEmail"
                                placeholder=""
                                className={`inputbox ${validationStates.curEmail === false ? 'error' : ''}`}
                                onBlur={() => validateInput('curEmail', /^[\w.+-]+@[\w-]+\.[\w.-]+$/)}

                            />
                            {hoveredField === 'curEmail' && (
                                <div className="hover-description">
                                    Enter email
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br />

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>New Provider</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('newName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Name*</label> <br />
                            <input
                                type="text"
                                id="newName"
                                value={NEW_PROVIDER_NAME}
                                readOnly
                                className="inputbox"
                            />
                            {hoveredField === 'newName' && (
                                <div className="hover-description">
                                    Enter address
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('newAddress')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address*</label> <br />
                            <input
                                type="text"
                                id="newAddress"
                                value={NEW_PROVIDER_ADDRESS}
                                readOnly
                                title={NEW_PROVIDER_ADDRESS}
                                className="inputbox"
                            />
                            {hoveredField === 'newAddress' && (
                                <div className="hover-description">
                                    Must be address in UK
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('newEmail')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Email*</label> <br />
                            <input
                                type="text"
                                id="newEmail"
                                value={NEW_PROVIDER_EMAIL}
                                readOnly
                                className="inputbox"
                            />
                            {hoveredField === 'newEmail' && (
                                <div className="hover-description">
                                    Enter email
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br />

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Numbers to be ported</h2> <br></br>

                    <Row>
                        <Col>
                            <div>
                                <input
                                    type="checkbox"
                                    id="checkBox"
                                    name="checkBox"
                                    checked={checkBox} // Bind state to checked attribute
                                    onChange={(e) => setCheckBox(e.target.checked)} // Handle checkbox change
                                />
                                <label htmlFor="mainline">&nbsp;Check for geo numbers only, for non geo keep this un-checked</label>
                            </div>
                        </Col>
                    </Row>

                    <br />

                    {checkBox && ( // Conditionally render this block
                        <Row>
                            <Col
                                onMouseEnter={() => handleMouseEnter('mbn')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>MBN*</label> <br />
                                <input
                                    onChange={(e) => setMbn(e.target.value)}
                                    type="text"
                                    id="mbn"
                                    value={mbn}
                                    placeholder=""
                                    className={`inputbox ${validationStates.mbn === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('mbn', /^\d{10,11}$/)}
                                />
                                {hoveredField === 'mbn' && (
                                    <div className="hover-description">
                                        Add MBN for above records. In case MBN has NOT to be ported keep this field empty.
                                    </div>
                                )}
                                {validationStates.mbn === false && (
                                    <div className="error-message" style={{ color: 'red', marginTop: '5px' }}>
                                        MBN must be a 10-11 digit number.
                                    </div>
                                )}
                            </Col>
                            <Col></Col>
                        </Row>
                    )}

                    <br></br>

                    <Row>
                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileName && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Uploaded File: {uploadedFileName}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>First number in range*</th>
                                <th>Last number in range*</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map(row => (
                                <tr key={row.id}>
                                    <td>
                                        <input
                                            type="text"
                                            id={`start-${row.id}`} // Dynamic ID for start input
                                            value={row.FirstNumber}
                                            onChange={(e) => handleChange_table(row.id, 'FirstNumber', e.target.value)}
                                            className={`inputbox ${validationStates[`start-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={(e) => {
                                                const startValue = e.target.value;
                                                const start = parseInt(startValue, 10);
                                                const end = parseInt(row.LastNumber, 10);

                                                // Validate the input for exactly 10 digits
                                                if (!/^\d{10,11}$/.test(startValue)) {
                                                    toast.error('Start range must be a 10-11 digit number');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`start-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`start-${row.id}`]: true,
                                                    }));

                                                    // Check if end range is valid
                                                    if (row.LastNumber) {
                                                        if (end < start) {
                                                            toast.error('End range must be greater than or equal to start range');
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`end-${row.id}`]: false,
                                                            }));
                                                        } else {
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`end-${row.id}`]: true,
                                                            }));
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            id={`end-${row.id}`} // Dynamic ID for end input
                                            value={row.LastNumber}
                                            onChange={(e) => handleChange_table(row.id, 'LastNumber', e.target.value)}
                                            className={`inputbox ${validationStates[`end-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={(e) => {
                                                const endValue = e.target.value;
                                                const start = parseInt(row.FirstNumber, 10);
                                                const end = parseInt(endValue, 10);

                                                // Validate the input for exactly 10 digits
                                                if (!/^\d{10,11}$/.test(endValue)) {
                                                    toast.error('End range must be a 10-11 digit number');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`end-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`end-${row.id}`]: true,
                                                    }));

                                                    // Check if end range is valid
                                                    if (row.FirstNumber) {
                                                        if (end < start) {
                                                            toast.error('End range must be greater than or equal to start range');
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`start-${row.id}`]: false,
                                                                [`end-${row.id}`]: false,
                                                            }));
                                                        } else {
                                                            setValidationStates(prev => ({
                                                                ...prev,
                                                                [`start-${row.id}`]: true,
                                                                [`end-${row.id}`]: true,
                                                            }));
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <button onClick={addRow}>Add Row</button>
                    {tableData.length > 1 && (
                        <button onClick={() => removeRow(tableData[tableData.length - 1].id)} style={{ marginLeft: '10px' }}>Remove Last Row</button>
                    )}

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Site address to register against numbers</h2> <br></br>

                    <h6 className='heading'>This is the address(must be in United Kingdom) of the location where the number(s) are to be registered against after porting, this could be the same or new location</h6>

                    <br></br>
                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('bName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Building Name/Number*</label> <br />
                            <input
                                onChange={(e) => setBName(e.target.value)}
                                type="text"
                                id="bName"
                                placeholder=""
                                className={`inputbox ${validationStates.bName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('bName', /^[a-zA-Z0-9\s,.'-]+$/)}

                            />
                            {hoveredField === 'bName' && (
                                <div className="hover-description">
                                    Enter Building number/name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('sName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Street Name*</label> <br />
                            <input
                                onChange={(e) => setSName(e.target.value)}
                                type="text"
                                id="sName"
                                placeholder=""
                                className={`inputbox ${validationStates.sName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('sName', /^[a-zA-Z0-9\s,.'-]+$/)}

                            />
                            {hoveredField === 'sName' && (
                                <div className="hover-description">
                                    Enter Street name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('town')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Town/City*</label> <br />
                            <input
                                onChange={(e) => setTown(e.target.value)}
                                type="text"
                                id="town"
                                placeholder=""
                                className={`inputbox ${validationStates.town === false ? 'error' : ''}`}
                                onBlur={() => validateInput('town', /^[a-zA-Z0-9\s,.'-]+$/)}

                            />
                            {hoveredField === 'town' && (
                                <div className="hover-description">
                                    Enter town
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('country')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Country*</label> <br />
                            <input
                                onChange={(e) => setCountry(e.target.value)}
                                type="text"
                                id="country"
                                placeholder=""
                                className={`inputbox ${validationStates.country === false ? 'error' : ''}`}
                                onBlur={() => validateInput('country', /^[a-zA-Z0-9\s,.'-]+$/)}

                            />
                            {hoveredField === 'country' && (
                                <div className="hover-description">
                                    Enter country
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('postCode')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Post Code*</label> <br />
                            <input
                                onChange={(e) => setPostCode(e.target.value)}
                                type="text"
                                id="postCode"
                                placeholder=""
                                className={`inputbox ${validationStates.postCode === false ? 'error' : ''}`}
                                onBlur={() => validateInput('postCode', /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i)}

                            />
                            {hoveredField === 'postCode' && (
                                <div className="hover-description">
                                    Enter Postal code (example for the postal code validation: SW1A 1AA)
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <br />

                </Container>

                <br></br>

                <Container>

                    <h2 className='heading'>Customer's Company Details</h2> <br></br>

                    <h6 className='heading'>This is the address(must be in United Kingdom) of the location which the current provider holds on record for the number(s). Normally verify this address against the billing records for the site, it is possible that the losing carrier address for the number is different from the physical address.</h6>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('cBName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Building Name/Number*</label> <br />
                            <input
                                onChange={(e) => setCBName(e.target.value)}
                                type="text"
                                id="cBName"
                                placeholder=""
                                className={`inputbox ${validationStates.cBName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('cBName', /^[a-zA-Z0-9\s,.'-]+$/)}

                            />
                            {hoveredField === 'cBName' && (
                                <div className="hover-description">
                                    as shown on most recent bill from current provider
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('cSName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Street Name*</label> <br />
                            <input
                                onChange={(e) => setCSName(e.target.value)}
                                type="text"
                                id="cSName"
                                placeholder=""
                                className={`inputbox ${validationStates.cSName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('cSName', /^[a-zA-Z0-9\s,.'-]+$/)}

                            />
                            {hoveredField === 'cSName' && (
                                <div className="hover-description">
                                    Enter Street name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('cTown')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Town/City*</label> <br />
                            <input
                                onChange={(e) => setCTown(e.target.value)}
                                type="text"
                                id="cTown"
                                placeholder=""
                                className={`inputbox ${validationStates.cTown === false ? 'error' : ''}`}
                                onBlur={() => validateInput('cTown', /^[a-zA-Z0-9\s,.'-]+$/)}  
                            />
                            {hoveredField === 'cTown' && (
                                <div className="hover-description">
                                    Enter town
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('cCountry')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Country*</label> <br />
                            <input
                                onChange={(e) => setCCountry(e.target.value)}
                                type="text"
                                id="cCountry"
                                placeholder=""
                                className={`inputbox ${validationStates.cCountry === false ? 'error' : ''}`}
                                onBlur={() => validateInput('cCountry', /^[a-zA-Z0-9\s,.'-]+$/)}

                            />
                            {hoveredField === 'cCountry' && (
                                <div className="hover-description">
                                    Enter country
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('cPostCode')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Post Code*</label> <br />
                            <input
                                onChange={(e) => setCPostCode(e.target.value)}
                                type="text"
                                id="cPostCode"
                                placeholder=""
                                className={`inputbox ${validationStates.cPostCode === false ? 'error' : ''}`}
                                onBlur={() => validateInput('cPostCode', /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i)}

                            />
                            {hoveredField === 'cPostCode' && (
                                <div className="hover-description">
                                    Enter Postal code
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('cRegNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Company's Registration Number*</label> <br />
                            <input
                                onChange={(e) => setCRegNum(e.target.value)}
                                type="text"
                                id="cRegNum"
                                placeholder=""
                                className={`inputbox ${validationStates.cRegNum === false ? 'error' : ''}`}
                                onBlur={() => validateInput('cRegNum', /^[a-zA-Z0-9\s,.'-]+$/)}
                            />
                            {hoveredField === 'cRegNum' && (
                                <div className="hover-description">
                                    Enter number
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('accNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Billing Account*</label> <br />
                            <input
                                onChange={(e) => setAccNum(e.target.value)}
                                type="text"
                                id="accNum"
                                placeholder=""
                                className={`inputbox ${validationStates.accNum === false ? 'error' : ''}`}
                                onBlur={() => validateInput('accNum', /^[a-zA-Z0-9\s,.'-]+$/)}
                            />
                            {hoveredField === 'accNum' && (
                                <div className="hover-description">
                                    Geo only
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br />

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Requester details</h2> <br></br>


                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('signature')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Signature*</label> <br />
                            <input
                                onChange={(e) => setSignature(e.target.value)}
                                type="text"
                                id="signature"
                                placeholder=""
                                className={`inputbox ${validationStates.signature === false ? 'error' : ''}`}
                                onBlur={() => validateInput('signature', /^[a-zA-Z0-9\s,.'-]+$/)}
                            />
                            {hoveredField === 'signature' && (
                                <div className="hover-description">
                                    Enter signature.
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('name')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Print Name*</label> <br />
                            <input
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                id='name'
                                placeholder=""
                                className={`inputbox ${validationStates.name === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name', /^[a-zA-Z0-9\s,.'-]+$/)}
                            />
                            {hoveredField === 'name' && (
                                <div className="hover-description">
                                    Enter Print name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('title')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Job Title*</label> <br />
                            <input
                                onChange={(e) => setTitle(e.target.value)}
                                type="text"
                                id='title'
                                placeholder=""
                                className={`inputbox ${validationStates.title === false ? 'error' : ''}`}
                                onBlur={() => validateInput('title', /^[a-zA-Z0-9\s,.'-]+$/)}
                            />
                            {hoveredField === 'title' && (
                                <div className="hover-description">
                                    Enter job title
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col>
                            <label>Date*</label> <br />
                            <input
                                onChange={(e) => setDate(e.target.value)}
                                type="date"
                                id="date"
                                value={date} // Automatically set the current date
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                            />
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('email')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Email*</label> <br />
                            <input
                                onChange={(e) => setEmail(e.target.value)}
                                type="text"
                                id='email'
                                placeholder=""
                                className={`inputbox ${validationStates.email === false ? 'error' : ''}`}
                                onBlur={() => validateInput('email', /^[\w.+-]+@[\w-]+\.[\w.-]+$/)}
                            />
                            {hoveredField === 'email' && (
                                <div className="hover-description">
                                    Enter email
                                </div>
                            )}
                        </Col>

                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>

            </div>

        </div>
    );

}

export default UkIreland;